import React, { CSSProperties } from 'react';
import classes from './Spinner.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';


export enum ESpinnerSize {
  SMALL, MEDIUM, LARGE
}

export enum ESpinnerColor {
  CONTENT, PRIMARY
}

interface IProps {
  color?: ESpinnerColor;
  size?: ESpinnerSize;
  center?: boolean;
  style?: CSSProperties;
}

const Spinner:React.FC<IProps> = ({ center, color = ESpinnerColor.PRIMARY, size = ESpinnerSize.MEDIUM, style }) => {
  const containerClassNames: string[] = [];

  if (center) {
    containerClassNames.push(classes.Center);
  }

  switch (size) {
    case ESpinnerSize.SMALL: 
      containerClassNames.push(classes.SizeSmall);
      break;
    case ESpinnerSize.MEDIUM: 
      containerClassNames.push(classes.SizeMedium);
      break;
    case ESpinnerSize.LARGE: 
      containerClassNames.push(classes.SizeLarge);
      break;
  }

  switch (color) {
    case ESpinnerColor.CONTENT:
      containerClassNames.push(classes.ColorContent);
      break;
    default:
      containerClassNames.push(classes.ColorPrimary);
      break;
  }

  return (
    <div className={containerClassNames.join(' ')} style={style}>
      <FontAwesomeIcon icon={faSpinner} spin />
    </div>
  )
}

export default Spinner